import { ValidationSchemaProps } from '@/hooks/useYupValidationResolver/old'
import * as Yup from 'yup'

type ValidateResponse = {
  isException: boolean
}

const schema = {
  exceptionReason: Yup.string()
    .required('Digite o motivo utilizando no mínimo 50 caracteres.')
    .min(50, 'Digite o motivo utilizando no mínimo 50 caracteres.')
    .nullable(),
}

function createAppointmentExceptionValidate({
  isException,
}: ValidateResponse): ValidationSchemaProps {
  const { exceptionReason } = schema

  const data = {
    exceptionReason: isException && exceptionReason,
  }

  return Yup.object().shape(data)
}

export { createAppointmentExceptionValidate }
